<template>
  <section class="section">
    <h2 class="section-title">联系我们</h2>

    <div class="contact-list">
      <div class="contact-item" v-for="(value, label) in contactInfo" :key="label">
        <div class="contact-label">{{ label }}</div>
        <div class="contact-value">{{ value }}</div>
      </div>
    </div>

    <div class="wechat-area">
      <p>欢迎扫码添加微信联系：</p>
      <img :src="wechatQr" alt="微信二维码" class="wechat-qr" />
    </div>
  </section>
</template>

<script setup>
const contactInfo = {
  '公司名称': '深圳量德信息技术有限公司',
  '地址': '深圳市龙岗南联',
  '电话': '18038056548',
  '邮箱': '1685533260@qq.com',
  '网站': 'www.ldinformation.com'
}

// 替换为你的二维码图片路径
const wechatQr = new URL('@/assets/wechat-qr.png', import.meta.url).href
</script>

<style scoped>
 .section {
  width: 800px;
  margin-left: 50px; /* 控制左边间距 */
  padding: 2em 1em;
  box-sizing: border-box;
  text-align: left;
}


.section-title {
  font-size: 1.8em;
  font-weight: bold;
  margin-bottom: 1.5em;
  color: #0a74da;
  text-align: center;
}

.contact-list {
  display: flex;
  flex-direction: column;
  gap: 1em;
  margin-bottom: 2em;
}

.contact-item {
  background: #f9f9f9;
  padding: 1em 1.2em;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
}

.contact-label {
  font-weight: bold;
  color: #007acc;
  margin-bottom: 0.3em;
}

.contact-value {
  color: #333;
  font-size: 0.95em;
}

.wechat-area {
  text-align: center;
  font-size: 16px;
  color: #333;
}

.wechat-qr {
  width: 200px;
  height: 200px;
  margin-top: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  object-fit: contain;
}
</style>
